import { RefObject, useEffect, useRef, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { deliveryClientNBC } from "../api/cmsDeliveryClient";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { HeaderLayoutDetail } from "../models";
import HomeBanner from "./HomeBanner";
import { getHeaderCMSCodesWithMapping } from "../utils/utilityfunctions";
import { getAccessCodeMappings } from "../utils/accessCodeMappings";

export type ContextData = {
  headerData: any,
  setActiveTab: Function,
  selectedTab: string,
  containerRef: RefObject<HTMLDivElement>
};

const NBCLayout = () => {
  const [visibleSection, setVisibleSection] = useState<string>("welcome");
  const containerRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  const updateActiveTab = (tab: string) => {
    setVisibleSection(tab);
  };

  const [contextDt, setContextDt] = useState<ContextData>({
    headerData: null,
    setActiveTab: updateActiveTab,
    selectedTab: "welcome",
    containerRef: containerRef
  });

  useEffect(() => {
    const userdetails = localStorage.getItem("userdetail");
    if (!userdetails) {
      navigate("/");
    } else {
      // CMS-driven: fetch header codes including reporting access from access_code_mapping
      getHeaderCMSCodesWithMapping(getAccessCodeMappings, deliveryClientNBC).then((codes) => {
        deliveryClientNBC.items()
          .anyFilter("elements.user_access__access_code", codes)
          .toPromise()
          .then(response => {
            const updatedHeaderData: ContextData = {
              headerData: response.data.items.filter(i => i.system.type === "header_layout_detail") as HeaderLayoutDetail[],
              setActiveTab: updateActiveTab,
              selectedTab: "welcome",
              containerRef: containerRef
            };
            setContextDt(updatedHeaderData);
          });
      });
    }
  }, []);

  const updateSelectedTab = (tab: string) => {
    const updatedHeaderData: ContextData = {
      headerData: contextDt.headerData,
      setActiveTab: updateActiveTab,
      selectedTab: tab,
      containerRef: containerRef
    };
    setContextDt(updatedHeaderData);
  };

  return (
    <div id="main-wrapper" ref={containerRef} className="main-wrapper">
      <Navbar
        navBarData={contextDt.headerData}
        activetab={visibleSection}
        updateSelectedTab={updateSelectedTab}
      />
      <div className="page-wrapper">
        <div className="container-fluid content-area">
          {visibleSection !== "reporting" && (
            <HomeBanner bannerData={contextDt.headerData} />
          )}
          <Outlet context={contextDt} />
        </div>
        <Footer /> 
      </div>
    </div>
  );
};

export default NBCLayout;
